const REFERENCE_MAX_LENGTH = 80;

export function normalizeMonzoReference(reference) {
  if (reference == null) return '';
  const cleaned = String(reference).replace(/\s+/g, ' ').trim();
  if (!cleaned) return '';
  return cleaned.slice(0, REFERENCE_MAX_LENGTH);
}

/**
 * Monzo.me payment link. `reference` is the `d` query (payment reference).
 */
export function buildMonzoPaymentLink(username, amount, reference) {
  const handle = typeof username === 'string' ? username.trim() : '';
  if (!handle) return null;

  const numeric = typeof amount === 'number' ? amount : parseFloat(amount);
  if (!Number.isFinite(numeric) || numeric <= 0) return null;

  const formattedAmount = numeric.toFixed(2);
  let url = `https://monzo.me/${encodeURIComponent(handle)}/${formattedAmount}`;

  const normalizedReference = normalizeMonzoReference(reference);
  if (normalizedReference) {
    url += `?d=${encodeURIComponent(normalizedReference)}`;
  }

  return url;
}
